<template>
  <section class="videoGallery" :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none' }">
    <Header v-if="!hideHeader" />
    <div class="videoGallery-container">
      <Banner :bannerSlot="'video_gallery_top_banner'" v-if="$store.state.template.banners.enableBanners" />
      <div class="foyerCategory-title" v-html="videoGalleryTitle" :style="{ backgroundColor: videosContainerBgColor }"></div>
      <div class="videoCards-container" :style="{ backgroundColor: videosContainerBgColor }">
        <VideoCard v-for="(videoCard, i) in page" :key="i" :videoCard="videoCard" @videoClicked="onVideoCardClicked(videoCard)" @downloadMaterialClicked="onDownloadMaterialClicked(videoCard.downloadUrl)" />
      </div>
      <div class="pagination-container">
        <pagination :key="paginationKey" :items="videoCards" :pageSize="itensPerPage" :labels="customLabels" @changePage="onChangePage" :styles="customStyles" />
      </div>
    </div>
    <div ref="popup" class="videoGallery-popup" v-if="showPopup">
      <div class="videoGallery-popup-close-btn" @click.prevent="handleClosePopup">
        <ion-icon name="close-circle" class="popup-close-circle-button"></ion-icon>
      </div>
      <div class="videoGallery-popup-video">
        <iframe class="popup-video-iframe" id="popup-iframe" :src="videoOnDisplay" frameborder="0" allow="autoplay; encrypted-media;" allowfullscreen></iframe>
      </div>
      <div class="videoGallery-instructions-and-radio-select-container" v-if="showPoll && showRating">
        <div class="videoGallery-instructions-container" v-html="reviewInstructions"></div>
        <div class="videoGallery-radio-select-container">
          <div class="radios-and-values-container">
            <div class="radio-values-combo" v-for="radio in 10" :key="radio">
              <input type="radio" name="radioId" @change="onRadioChange($event)" :value="radio" />
              <div class="radio-value-display">{{ radio }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-image-container" v-if="accessConfig.footerImage">
      <div v-html="accessConfig.footerImage"></div>
    </div>
    <Footer />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import VideoCard from '@/components/general/VideoCard.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';
import Banner from '@/components/banners/Banner.vue';

export default {
  name: 'VideoGallery',
  components: { Header, Banner, VideoCard, Footer },

  data() {
    return {
      hideHeader: true,
      accessConfig: {},
      showPoll: true,
      videoGalleryTitle: '',
      videosContainerBgColor: 'transparent',
      page: [],
      itensPerPage: 64,
      paginationKey: 0,
      customLabels: {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>',
      },
      customStyles: {
        ul: {
          visibility: 'hidden',
        },
        li: {
          display: 'inline-block',
          last: {
            display: 'none',
          },
        },

        a: {
          color: 'var(--input-text)',
          // border: '1px solid black',
          backgroundColor: '#20202010',
          borderRadius: '50%',
        },
      },
      activityData: { images: {}, property: {}, interactivities: [] },
      videoCards: [],
      pollIdOnDisplay: '',
      showPopup: false,
      showRating: true,
      videoOnDisplay: '',
      reviewInstructions: '<p><strong>Está gostando do conteúdo?</strong></p><p>Deixe uma nota de 1 a 10</p>',
    };
  },
  watch: {
    $route() {
      this.loadActivity();
    },
  },
  methods: {
    resized() {
      if (window.innerHeight < 460) this.showRating = false;
      else this.showRating = true;
    },
    goFullScreen() {
      let element = this.$refs.popup;
      if (!document.fullscreenElement) {
        if (element.requestFullScreen) {
          element.requestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        }
      } else {
        document.exitFullscreen();
      }
    },
    loadActivity() {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          // console.log(response);

          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

          let tempProperty = { ...this.activityData.property };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;
          this.hideHeader = this.activityData.property.hideHeader ? true : false;

          response.data.interactivity.forEach((item) => {
            this.activityData.interactivities[item.interactivity] = item.enable;
          });
        })
        .then(() => {
          this.videoCards = this.activityData.property.videoCards;
          this.videoGalleryTitle = this.activityData.property.sectionTitle;
          this.videosContainerBgColor = this.activityData.property.videosContainerBgColor;
          this.showPoll = this.activityData.property.showPoll;

          // Pagination visibility
          let counter = 0;
          this.videoCards.map(() => {
            counter++;
          });
          if (counter > this.itensPerPage) {
            this.customStyles.ul.visibility = 'visible';
            this.paginationKey = 1;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onChangePage(page) {
      this.page = page;
    },
    handleClosePopup() {
      this.pollIdOnDisplay = '';
      this.videoOnDisplay = '';
      this.imageOnDisplay = '';
      this.showPopup = false;
    },
    onVideoCardClicked(videoCard) {
      this.showPopup = true;
      this.videoOnDisplay = videoCard.video;
      this.pollIdOnDisplay = videoCard.poll_id;
      this.$nextTick(() => {
        if (window.innerWidth < 420 || window.innerHeight < 460) {
          this.goFullScreen();
        } else {
          window.scrollTo(0, 0);
        }
      });
      api.post(`sessionAction/`, {
        action: 'VideoGallery Action - video clicked',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, video: this.videoOnDisplay }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    onDownloadMaterialClicked(downloadUrl) {
      window.open(downloadUrl);
      // console.log('DOWNLOAD MATERIAL: ' + downloadUrl);
      api.post(`sessionAction/`, {
        action: 'VideoGallery Action - material download',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, material: downloadUrl }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    onRadioChange(event) {
      var data = event.target.value - 1;
      // console.log('Nota ' + data + ' para o video: ' + this.videoOnDisplay);
      api
        .post(`/answerPoll/${this.$route.params.stream}`, {
          userId: this.$store.state.user.id,
          poll_id: this.pollIdOnDisplay,
          answer: data,
          activity_id: this.$route.params.stream,
        })
        .then((response) => {
          // console.log(response);
        })
        .catch(() => {});
    },
  },

  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    this.loadActivity();
    if (window.innerHeight < 560) this.showRating = false;
  },
  created() {
    window.addEventListener('resize', this.resized);
    window.addEventListener('orientationchange', this.resized);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resized);
    window.removeEventListener('orientationchange', this.resized);
  },
};
</script>

<style lang="scss">
.videoGallery {
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100vw;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.videoGallery-container {
  position: relative;
  width: 100vw;
  min-height: 97vh;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.videoGallery-title {
  position: relative;
  align-self: center;
  text-align: center;
  padding-top: 1%;
  font-size: 2rem;
  width: 74vw;
  border-top-left-radius: var(--input-borderRadius);
  border-top-right-radius: var(--input-borderRadius);
}
.videoCards-container {
  position: relative;
  background-size: cover;
  background-repeat: repeat;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 74vw;
  // margin: 20px;
  padding-top: 20px;
  border-bottom-left-radius: var(--input-borderRadius);
  border-bottom-right-radius: var(--input-borderRadius);
}
.videoGallery-popup {
  position: absolute;
  background-size: cover;
  background-repeat: repeat;
  background-color: #000000f9;
  width: 100%;
  height: 200vh;
  z-index: 20;
  margin-top: 99px;
  @include media('<=phone') {
    margin-top: 50px;
  }
}
.videoGallery-popup-close-btn {
  position: relative;
  background-color: transparent;
  height: 8vh;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  .popup-close-circle-button {
    position: relative;
    cursor: pointer;
    font-size: 50px;
    color: white;
    margin-right: 14vw;
  }
}
.videoGallery-popup-video {
  position: relative;
  height: 30vw;
  margin: 10px;
  margin-top: 1.69%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  .popup-video-iframe {
    width: 64%;
    height: 35vw;
    border-radius: var(--input-borderRadius);
  }
}
.videoGallery-instructions-and-radio-select-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 18vw;
  background-color: #464646;
  color: white;
  border-radius: var(--input-borderRadius);
}
.videoGallery-instructions-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 3vw;
  p:first-child {
    font-size: 1.4rem !important;
  }
  p:last-child {
    color: #bbb;
  }
}
.videoGallery-radio-select-container {
  // background-color: red;
  position: relative;
  display: flex;
  width: 60%;
  height: 6vw;
  justify-content: center;
  align-items: center;
  border-radius: var(--input-borderRadius);
}
.radios-and-values-container {
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 300px;
  padding: 0 18px;
}
.radio-values-combo {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1.38vw;
  margin-top: 2vw;
  .radio-value-display {
    font-size: 0.9vw;
    margin-top: 0.6vw;
    color: #aaa;
  }
}
// BREAKPOINT
@include media('<=1242px') {
  // .videoGallery {
  //   // background-size: contain;
  // }
  .videoGallery-popup {
    // width: 100%;
    height: 100dvh;
  }

  .videoGallery-instructions-and-radio-select-container {
    flex-direction: column;
  }
  .videoGallery-instructions-container p {
    font-size: 1rem !important;
    margin: 0;
    margin-top: 6px;
  }
  .radio-values-combo {
    margin: 16px;
    .radio-value-display {
      font-size: 0.8rem;
      margin-top: 0.6vw;
    }
  }
}

@include media('<=phone-plus') {
  .videoGallery-popup {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .videoGallery-popup-close-btn {
    width: 100%;
    margin-top: 10px;
    .popup-close-circle-button {
      margin-right: 6px;
    }
  }
  .videoGallery-instructions-and-radio-select-container {
    height: 18% !important;
    margin: 0 16px !important;
  }

  .videoGallery-popup-video {
    height: 40vh;
    width: 96%;
    margin: 10px;
    justify-content: center;
    align-items: flex-end;
    .popup-video-iframe {
      width: 100%;
      height: 40vh;
    }
  }
  .videoGallery-instructions-and-radio-select-container {
    flex-direction: column;
    width: 96%;
    justify-content: space-around;
    align-items: center;
    height: 100px;
    margin: 0;
  }

  .videoGallery-instructions-container p {
    font-size: 1rem !important;
  }
  .radio-values-combo {
    margin: 2.5vw;
    .radio-value-display {
      font-size: 0.9rem;
      margin-top: 0.6vw;
    }
  }
}
</style>
